import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { finalChain } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-16 md:py-24" data-id="element-150" data-mp="1nn5a46fbpo9h">
      <div className="mx-auto max-w-3xl text-center" data-id="element-151" data-mp="1smhyivluf3e6">
        <h2 className="font-serif text-[32px] font-black leading-tight text-white md:text-5xl" data-id="element-152" data-mp="1eojkxsfcjazq">
          Are you ready to stop starting every case from a <span className="italic text-sky-light" data-id="element-153" data-mp="1irg8lxjqtxaj">blank page?</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-sky-light" data-id="element-154" data-mp="14r5gysam0eob">
          You don’t need another giant collection of disconnected orthodontic information. You need a way to organize what you already
          know — a structured framework to move from:
        </p>
        <ol className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-155" data-mp="343hqfq4a3g7o">
          {finalChain.map((step, i) => <li key={step} className="flex items-center gap-2" data-id="element-156" data-mp="27k1i9j9qkr5" data-mpi={i}>
              <span className="rounded-lg bg-navy-800 px-3 py-1.5 text-sm font-bold text-white" data-id="element-157" data-mp="3tfxwv1wgs0t0">{step}</span>
              {i < finalChain.length - 1 && <ArrowRightIcon className="h-4 w-4 text-sky" aria-hidden="true" data-id="element-158" data-mp="b0x4y5eyl4rh" />}
            </li>)}
        </ol>
        <p className="mx-auto mt-6 max-w-xl text-[17px] leading-relaxed text-sky-light" data-id="element-159" data-mp="71xy2f9o2xxe">
          And build that map in approximately <strong className="text-white" data-id="element-160" data-mp="3agtq5zseaj4i">15 minutes</strong> instead of staring at a blank page
          wondering where to begin.
        </p>

        <div className="mt-8" data-id="element-161" data-mp="3oh4kjcswyfuf">
          <p className="text-sm font-extrabold uppercase tracking-wider text-sky-light" data-id="element-162" data-mp="3odyrxnl2svty">Only</p>
          <p className="font-serif text-[88px] font-black leading-none text-white" data-id="element-163" data-mp="3jjcnk4dew3jd">$27</p>
          <p className="text-lg font-bold text-sky-light" data-id="element-164" data-mp="13s7047a2mlqf">USD</p>
        </div>

        <div className="mt-8" data-id="element-165" data-mp="yqhmqkzdlvz6">
          <CtaButton tone="dark" label="Get Ortho Treatment Map™" note="Immediate digital access · Lifetime access · One-time payment · 7-Day Guarantee" data-id="element-166" data-mp="ytdjw73eggmk" />
        </div>
        <Countdown tone="dark" data-id="element-167" data-mp="5e9r07xzl2gi" />
        <ScarcityBar tone="dark" data-id="element-168" data-mp="5fcj2j71pay0" />
      </div>
    </section>;
}